import { FC } from 'react';

export const Commodity: FC = () => (
  <svg fill="currentColor" viewBox="0 0 32 32" strokeWidth="2">
    <g>
      <path d="M31,30h-.31l-2.75-7.35A1,1,0,0,0,27,22H22A10,10,0,1,0,10,22H5a1,1,0,0,0-.94.65L1.31,30H1a1,1,0,0,0,0,2H31a1,1,0,0,0,0-2ZM8,14a8,8,0,1,1,8,8A8,8,0,0,1,8,14Zm8,10a10.71,10.71,0,0,0,1.61-.14L16,28.15l-1.61-4.29A10.71,10.71,0,0,0,16,24ZM3.44,30l2.25-6h6.62l2.25,6Zm14,0,2.25-6h6.62l2.25,6Z" />
      <path d="M16,17H14a1,1,0,0,0,0,2h1a1,1,0,0,0,2,0v-.18A3,3,0,0,0,16,13a1,1,0,0,1,0-2h2a1,1,0,0,0,0-2H17a1,1,0,0,0-2,0v.18A3,3,0,0,0,16,15a1,1,0,0,1,0,2Z" />
      <path d="M1,4H2V5A1,1,0,0,0,4,5V4H5A1,1,0,0,0,5,2H4V1A1,1,0,0,0,2,1V2H1A1,1,0,0,0,1,4Z" />
      <path d="M27,7h1V8a1,1,0,0,0,2,0V7h1a1,1,0,0,0,0-2H30V4a1,1,0,0,0-2,0V5H27a1,1,0,0,0,0,2Z" />
    </g>
  </svg>
);

export default Commodity;
